import { render, staticRenderFns } from "./userDashboardCustomerInfos.vue?vue&type=template&id=9b0e8e64"
import script from "./userDashboardCustomerInfos.vue?vue&type=script&lang=js"
export * from "./userDashboardCustomerInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports